export default __webpack_public_path__ + "static/media/Belt of Reckless Challenge.29d77b5b.jpg";